export default __webpack_public_path__ + "static/media/Heby.e52c9f10.png";